import { Card, CardContent, Grid, Typography } from '@material-ui/core'
import { useStyles } from './info-card.styles'

export const InfoCard = ({ value, color, label }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="subtitle1" dangerouslySetInnerHTML={{ __html: label }} />
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ color }} variant="subtitle2">
              {value}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
